import React, { useRef, useState } from "react";
import {
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  Grid,
  Paper,
  Box,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  DialogContent,
  CircularProgress,
  FormControl,
  Alert,
  Divider
} from "@mui/material";
import { useForm } from "react-hook-form";
import loginIllustration from ".././graphic.svg";
import { IconCheck, IconDeviceMobile, IconEye, IconEyeOff, IconLock, IconMail, IconMessages, IconPhone, IconUser, IconUserPlus } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BeatLoader } from "react-spinners";
import ReCAPTCHA from "react-google-recaptcha";
import PageContainer from "../Pages/Pagecontainer";
// import Logo from '.././Images/logo1.png'
import Logo from '.././Images/logo-dark.png'

const Signup = () => {
  const { register, handleSubmit, watch, formState: { errors }, trigger } = useForm();
  const navigate = useNavigate()
  const recaptchaRef = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [EmailError, setEmailError] = useState('')
  const [successpopup, setsuccesspopup] = useState(false)
  const [loading, setLoading] = useState(false);
  const onSubmit = async (data) => {
    // const token = recaptchaRef.current.getValue(); 
    // if (!token) {
    //   setEmailError('Please complete the reCAPTCHA.');
    //   return;
    // }
    try {
      setLoading(true)
      let config = axios.defaults.headers.common = { 'Authorization': `` }
      let req = {
        // fullname: data.fullName,
        first_name:data.firstName,
        last_name:data.lastName,
        mobile: data.mobile,
        email: data.email,
        company_name: data.company_name,
        password: data.password,
        confirm_password: data.confirmPassword
      };
      const response = await axios.post('apiV1/register/', req, config);
      console.log(response);
      if (response.status == 201) {
        setsuccesspopup(true)
        setLoading(false)
      }
    } catch (error) {
      console.error('Error generating test:', error.response ? error.response.data : error.message);
      setEmailError(error?.response?.data.email[0])
      setLoading(false)
    }
  };
  const postCaptcha = async (token) => {
    try {
      let req = {
        recaptcha_token: token
      }
      const response = await axios.post('/apiV1/protected/', req);
      console.log(response);
    }
    catch (error) {
      console.log('Error generating test:', error.response ? error.response.data : error.message);
    }
  }
  return (
    <>
      <PageContainer title="SmartInvestorDeck | Signup">
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          height="100vh"
          sx={{
            backgroundImage: `url(${loginIllustration})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "45%"
          }}
        >
          <Paper
            elevation={3}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              maxWidth: 450,
              width: "100%",
              padding: 4,
              background: "rgba(255, 255, 255, 0.9)",
              backdropFilter: "blur(10px)",
            }}
          >
            <Typography variant="h5" fontWeight="bold" textAlign="center" gutterBottom>
              Create Your Account Now
            </Typography>
            <Box sx={{ textAlign: "center", mb: 2 }}>
              <img src={Logo} alt="logo" style={{ width: "180px" }} />
              {/* <IconButton sx={{ backgroundColor: "#4b75fd", color: "white", padding: 3, "&:hover": { backgroundColor: "#4b75fd" } }}>
              <IconUserPlus color="#fff" size={50} />
            </IconButton> */}
            </Box>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl variant="standard" fullWidth margin="dense">
                <Typography variant="body2" gutterBottom>First Name</Typography>
                <TextField
                  fullWidth
                  id="fullName-input"
                  {...register("firstName", {
                    required: "First Name is required",
                    pattern: {
                      value: /^(?! )[a-zA-Z ]+$/,
                      message: "First Name must start with an alphabet. Only alphabets and spaces are allowed",
                    },
                  })}
                  onKeyUp={() => trigger("firstName")}
                  error={!!errors.firstName}
                  helperText={errors.firstName?.message}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth margin="dense">
                <Typography variant="body2" gutterBottom>Last Name</Typography>
                <TextField
                  fullWidth
                  id="fullName-input"
                  {...register("lastName", {
                    required: "Last Name is required",
                    pattern: {
                      value: /^(?! )[a-zA-Z ]+$/,
                      message: "Last Name must start with an alphabet. Only alphabets and spaces are allowed",
                    },
                  })}
                  onKeyUp={() => trigger("lastName")}
                  error={!!errors.lastName}
                  helperText={errors.lastName?.message}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth margin="dense">
                <Typography variant="body2" gutterBottom>Company Name</Typography>
                <TextField
                  fullWidth
                  id="fullName-input"
                  {...register("company_name", {
                    required: "Company  Name is required",
                    pattern: {
                      value: /^(?! )[a-zA-Z ]+$/,
                      message: "Company Name must start with an alphabet. Only alphabets and spaces are allowed",
                    },
                  })}
                  onKeyUp={() => trigger("company_name")}
                  error={!!errors.company_name}
                  helperText={errors.company_name?.message}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth margin="dense">
                <Typography variant="body2" gutterBottom>Email</Typography>
                <TextField
                  fullWidth
                  id="email-input"
                  {...register("email", {
                    required: "Email is required",
                    pattern: { value: /^\S+@\S+\.\S+$/, message: "Enter a valid email" },
                  })}
                  onKeyUp={() => trigger("email")}
                  error={!!errors.email}
                  helperText={errors.email?.message}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth margin="dense">
                <Typography variant="body2" gutterBottom>Mobile Number</Typography>
                {/* <TextField
                  fullWidth
                  id="mobile-input"
                  type="tel"
                  {...register("mobile", {
                    required: "Mobile Number is required",
                    pattern: {
                      value: /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?){1,2}\d{4}$/,
                      message: "Enter a valid phone number",
                    },
                  })}
                  onKeyUp={() => trigger("mobile")}
                  error={!!errors.mobile}
                  helperText={errors.mobile?.message}
                /> */}
              <TextField
                fullWidth
                id="mobile-input"
                type="tel"
                inputProps={{ inputMode: "tel", maxLength: 15 }}
                {...register("mobile", {
                  required: "Mobile Number is required",
                  pattern: {
                    value: /^(?! )[+0-9()\-\s]{8,15}$/,
                    message: "Enter a valid number (no space at start, allow +()- and digits)",
                  },
                  minLength: {
                    value: 8,
                    message: "Mobile number must be at least 8 digits",
                  },
                  maxLength: {
                    value: 15,
                    message: "Mobile number must not exceed 15 digits",
                  },
                })}
                onKeyUp={() => trigger("mobile")}
                error={!!errors.mobile}
                helperText={errors.mobile?.message}
              />

                {/* <TextField
                fullWidth
                id="mobile-input"
                type="tel"
                {...register("mobile", {
                  required: "Mobile Number is required",
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Only numeric values are allowed",
                  },
                  minLength: {
                    value: 10,
                    message: "Mobile number must be at least 10 digits",
                  },
                  maxLength: {
                    value: 12,
                    message: "Mobile number must not exceed 12 digits",
                  },
                })}
                inputProps={{
                  maxLength: 12,
                }}
                onKeyUp={() => trigger("mobile")}
                error={!!errors.mobile}
                helperText={errors.mobile?.message}
              /> */}
              </FormControl>
              {/* Password */}
              <FormControl variant="standard" fullWidth >
                <Typography variant="body2" gutterBottom>Password</Typography>
                <TextField
                  fullWidth
                  id="password-input"
                  type={showPassword ? "text" : "password"}
                  {...register("password", {
                    required: "Password is required",
                    pattern: {
                      value: /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,16}$/,
                      message: "Password must be 8-16 characters, with at least one digit, one lowercase, and one uppercase letter.",
                    },
                  })}
                  onKeyUp={() => trigger("password")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                          {showPassword ? <IconEye /> : <IconEyeOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={!!errors.password}
                  helperText={errors.password?.message}
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                />
              </FormControl>
              <FormControl variant="standard" fullWidth margin="dense">
                <Typography variant="body2" gutterBottom>Confirm Password</Typography>
                <TextField
                  fullWidth
                  id="confirm-password-input"
                  type={showConfirmPassword ? "text" : "password"}
                  {...register("confirmPassword", {
                    required: "Confirm Password is required",
                    validate: (value) => value === watch("password") || "Passwords do not match",
                  })}
                  onKeyUp={() => trigger("confirmPassword")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                          {showConfirmPassword ? <IconEye /> :  <IconEyeOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={!!errors.confirmPassword}
                  helperText={errors.confirmPassword?.message}
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                />
              </FormControl>
              {/* <Box mt={2} mb={2}>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6Lf0_dsqAAAAABJDHl5yA5Qb3rpdFD9ovNYdkuJ8"
                onChange={(token) => { postCaptcha(token); EmailError("") }} 
                sx={{width:"100%"}}/>
            </Box> */}
              {EmailError && <Alert severity="error">{EmailError}</Alert>}
              {/* Submit Button */}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                sx={{ mt: 3, textAlign: "center", gap: 1 }}
                disabled={loading}
                className="button2"
              >
                {loading ? <BeatLoader size={20} color="#fff" /> : <Typography>Sign Up</Typography>}
              </Button>

            </form>



            <Typography
              variant="body2"
              textAlign="center"
              sx={{ mt: 2, display: "flex", justifyContent: "center" }}
            >
              Already have an account?
              <Typography
                component="span"
                variant="body2"
                sx={{ color: "#07659c", ml: 1, cursor: "pointer" }}
                onClick={() => navigate("/")}
              >
                Sign In
              </Typography>
            </Typography>
          </Paper>
        </Grid>
        <Dialog
          open={successpopup}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              setsuccesspopup(false);
            }
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="md"
          sx={{ textAlign: "center", maxWidth: "700px", margin: "auto" }}
        >
          <DialogTitle sx={{ fontWeight: "bold" }}>
            Success
          </DialogTitle>
          <Divider />
          <DialogContent>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <IconButton
                disableRipple
                sx={{
                  backgroundColor: "#0e860e",
                  padding: 3,
                  "&:hover": { backgroundColor: "#0e860e" }
                }}
              >
                <IconCheck color="#fff" size={30} />
              </IconButton>
            </Box>

            <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
              Welcome!<br />
              Registration successful!<br />Please check your email for the activation link to activate your account.
            </DialogContentText>
          </DialogContent>

          <Divider />

          <DialogActions>
            <Button
              onClick={() => { setsuccesspopup(false); navigate("/"); }}
              sx={{
                olor: "#fff",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
              className="button2"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </PageContainer>
    </>

  );
};

export default Signup;
